import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';
import { buildLeadSourceOptions } from '@/lib/leadSources';
import { mergeDoctorLeadSourceOptions } from '@/lib/doctorLeadSources';

export function useDoctorLeadSourceOptions(hospitalId?: string) {
  const { user, activeHospitalId } = useAuth();
  const hid = hospitalId ?? activeHospitalId ?? user?.hospitalId;

  const query = useQuery({
    queryKey: ['doctor-lead-sources', hid],
    queryFn: async () => {
      const res = await api.get<{ message: string; data: { sources: Array<{ value: string; label: string }> } }>(
        '/api/doctor-team/lead-sources',
        { params: hid ? { hospitalId: hid } : undefined }
      );
      return res.data.data?.sources ?? [];
    },
    enabled: !!hid,
    staleTime: 60_000,
  });

  const options = mergeDoctorLeadSourceOptions(
    buildLeadSourceOptions(),
    query.data
  );

  return { options, doctorSources: query.data ?? [], isLoading: query.isLoading };
}
